module.exports = __webpack_public_path__ + "static/media/rate-us.b6c1e086.jpg";